import { useState } from 'react';
import { ApiCallError } from '../api/client';
import { sysApi, setSysToken } from '../api/sysadmin';

export default function SysAdminLoginPage({ onLogin }: { onLogin: (user: string) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit() {
    setErr(null);
    if (!username || !password) { setErr('请填账号和密码'); return; }
    setLoading(true);
    try {
      const r = await sysApi.login(username, password);
      setSysToken(r.token);
      onLogin(username);
    } catch (e) {
      setErr(e instanceof ApiCallError ? e.message : '登录失败');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page" style={{ maxWidth: 420 }}>
      <div style={{ textAlign: 'center', marginTop: 40, marginBottom: 24 }}>
        <div style={{ fontSize: 48 }}>🛠️</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, marginTop: 8 }}>系统管理后台</h1>
        <div className="muted" style={{ marginTop: 4 }}>查看资源、用户信息、重置密码</div>
      </div>

      <div className="card">
        <label style={{ display: 'block', fontWeight: 700, marginBottom: 6 }}>账号</label>
        <input
          autoComplete="username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()}
        />
        <label style={{ display: 'block', fontWeight: 700, margin: '12px 0 6px' }}>密码</label>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()}
        />
        {err && <div className="error-box">{err}</div>}
        <button
          className="btn btn-primary btn-block"
          style={{ marginTop: 16 }}
          disabled={loading}
          onClick={submit}
        >
          {loading ? <span className="spinner" /> : '登录'}
        </button>
      </div>
    </div>
  );
}
